export default __webpack_public_path__ + "static/9-a0264896ffe32894972737f202572373.webp";